// refers to wallet-manager-backend/src/config/const.ts
// only these tokens have a price
export const knownTokens = [
  'btc',
  'eth',
  'apt',
  'usdc',
  'usdt',
  'weth',
  'dai',
  'wbtc',
  'bnb',
  'aptoge',
  'mojo',
  'stapt',
  'sol',
  'cake',
  'tapt',
  'thl',
  'abel',
  'alt',
  'amapt',
  'mbx',
  'props',
  'doodoo',
  'gari',
  'returd',
  'shrimp',
  'apts',
  'uptos',
  // 'chewy', need to wait for listing chewy on CMC. right now API return incorrect price from aptostop.
];

export const BRIDGES = ['celer', 'wormhole', 'layerzero'];


